import { FC, lazy, Suspense } from 'react'
import { FullLoader } from '../shared'
import { AIConsultationOwnProps } from './AIConsultation.model'

const LazyAIConsultation = lazy(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "ai_assistant" */ './AIConsultation.container'
  ).then(({ AIConsultation }) => ({ default: AIConsultation })),
)

const LazyLoadedAIConsultation: FC<AIConsultationOwnProps> = (props) => (
  <Suspense fallback={<FullLoader />}>
    <LazyAIConsultation {...props} />
  </Suspense>
)

export { LazyLoadedAIConsultation as AIConsultation }
